var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudio = function SvgAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.963 13.1c0-5.015-2.603-8.01-6.963-8.01S5.037 8.085 5.037 13.1a7.34 7.34 0 0 0 .773 3.556c.804 1.323 1.439 2.117 3.09 2.117.105 0 .19 0 .19-.202v-3.957c0-.138 0-.201-.19-.201a2.24 2.24 0 0 0-2.117 1.322 6.6 6.6 0 0 1-.434-2.634c0-2.519.71-6.752 5.651-6.752 4.942 0 5.672 4.233 5.672 6.72a6.6 6.6 0 0 1-.466 2.635 2.24 2.24 0 0 0-2.116-1.323c-.148 0-.201.063-.201.201v3.979c0 .17.095.2.201.2 1.661 0 2.296-.803 3.1-2.116a7.34 7.34 0 0 0 .773-3.544"
  })));
};
export default SvgAudio;